<template>
  <div class="content">
    <h4>
      GM权限简介:
    </h4>
    <p>
      玩家通过本后台花费少量金钱开通游戏特殊GM权限后，可在GM权限后台中享受自助刷无限元宝、等级秒升、超级装备自刷、自助转区等GM权限。
    </p>
    <h4>权限说明:</h4>
    <p>
      解锁高档位权限包含低档位权限，例:开通了98元权限包含30元6元等低档位权限。
    </p>
    <h4>1.如何开通权限</h4>
    <img src="../../assets/GMdesc/open.png" alt="" />
    <h4>2.如何使用权限后台</h4>
    <img src="../../assets/GMdesc/use.png" alt="" />
    <h4>3.转区/转游说明</h4>
    <p>
      转区/转游需要支付50%的费用，每个所选老游戏/老区老角色仅能一次，转移转移后将无法撤回，老游戏权限收回并开通至新游戏/新区新角色。
    </p>
    <img src="../../assets/GMdesc/change1.png" alt="" />
    <img src="../../assets/GMdesc/change2.png" alt="" />
  </div>
</template>
<style scoped>
.content {
  padding: 32px;
}
img {
  width: 100%;
}
h4 {
  margin: 18px 0;
}
p:nth-of-type(2),
p:nth-of-type(3) {
  margin-bottom: 60px;
}
</style>
